/* -------------------------------------------------------------------------- */
/*                                  Packages                                  */
/* -------------------------------------------------------------------------- */
import * as React from "react"
import { SEO } from "@abmg-components"

/* -------------------------------------------------------------------------- */
/*                                 Components                                 */
/* -------------------------------------------------------------------------- */
import Hero from "@components/referral/hero"
import Form from "@components/referral/form"

/* -------------------------------------------------------------------------- */
/*                              Default Function                              */
/* -------------------------------------------------------------------------- */
export default function ReferralTemplate(props) {
  const [teExternalId, setTEExternalId] = React.useState(null)
  React.useEffect(() => {
    const searchParams = new URLSearchParams(props.location.search)
    if (searchParams) {
      const externalId = searchParams.get("external_id")
      setTEExternalId(externalId)
    }
  }, [])
  return (
    <>
      <Hero />
      <Form bankerData={props.bankerData} externalId={teExternalId} />
    </>
  )
}

/* -------------------------------- Meta Tags ------------------------------- */
export const Head = props => {
  return (
    <SEO
      title={`Refer Friends & Family | Atlantic Bay Mortgage Referral`}
      description={`Know someone buying or refinancing a home? Refer them to Atlantic Bay—trusted by you for expert mortgage guidance your friends and family can count on.`}
      slug={props.location.pathname.replace(/^\//, "").replace(/\/$/, "")}
    ></SEO>
  )
}
